<template>
  <div class="device-con">
    <div class="tabs">
      <div :class="{ item: true, active: activeTab === 1 }" @click="activeTab = 1">收款码</div>
      <div :class="{ item: true, active: activeTab === 2 }" @click="activeTab = 2">云喇叭</div>
      <div :class="{ item: true, active: activeTab === 3 }" @click="activeTab = 3">收款设备</div>
      <div :class="{ item: true, active: activeTab === 4 }" @click="activeTab = 4">PC插件</div>
    </div>
    <div class="search">
      <el-row :gutter="3" v-if="shopType">
        <el-col :span="1.5">
          <div class="label">选择门店</div>
        </el-col>
        <el-col :span="3">
          <custom-select v-model="searchForm.merchantIdList" :list="shopList"></custom-select>
        </el-col>
      </el-row>
      <el-form inline class="inline-form" :model="searchForm" label-width="80px" label-position="left">
        <el-form-item label="设备编号" >
          <el-input v-model="searchForm.transToolNum" placeholder="请输入设备编号" style="width:310px;" size="small"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" style="margin-left: 30px">
          <el-input v-model="searchForm.transToolCustomerName" placeholder="请输入设备名称" style="width:310px;" size="small"></el-input>
        </el-form-item>
        <el-button type="primary" @click="search" class="btnBase">查询</el-button>
      </el-form>
    </div>
    <div class="table-list">
      <div class="tabledata-con">
        <el-table :data="tableData" style="width: 100%" border v-loading="loadingTable">
          <el-table-column prop="transToolNum" :label="activeTab == 1 || activeTab == 2 ? '码牌编号' : '设备编号'" align="center"></el-table-column>
          <el-table-column prop="transToolCustomerName" :label="activeTab == 1 || activeTab == 2 ? '码牌名称' : '设备名称'" align="center"></el-table-column>
          <el-table-column prop="merchantName" label="所属门店" align="center"></el-table-column>
          <el-table-column prop="transToolName" label="设备类型" align="center"> </el-table-column>
          <!-- <el-table-column prop="pcActiveCode" label="激活码" align="center" v-if="activeTab == 4"> </el-table-column> -->
          <el-table-column prop="bindTime" :label="activeTab == 1 || activeTab == 2 ? '绑定时间' : '激活时间'" align="center"> </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <div v-if="activeTab == 3">{{ scope.row.status == 0 ? "未激活" : "已激活" }}</div>
              <div v-if="activeTab == 4">{{ scope.row.status == 2 ? "已绑定" : "已激活" }}</div>
              <div v-if="activeTab == 1||activeTab == 2">{{ scope.row.status == 0 ? "关闭" : "启用" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span class="table-btn" @click="viewCodeDetial(scope.row)" v-if="activeTab == 1">查看</span>
              <span class="table-btn last-btn" @click="modifyDetial(scope.row)">修改</span>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            prev-text="上一页"
            next-text="下一页"
            :page-size="page.pageSize"
            layout="prev, pager,total,next"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"
          >
          </el-pagination>
        </el-col>
      </div>
    </div>
    <!-- 查看弹窗 -->
    <el-dialog :visible.sync="coedDialog" width="30%">
      <div class="code" v-loading="codeLoading">
        <div class="money text" v-if="code.fixedAmount!=null&&code.fixedAmount!=0"><span>￥</span>{{ code.fixedAmount/100 }}</div>
        <div class="name text">{{ code.fixedQrcodeDescription }}</div>
        <div class="codeImg">
          <vue-qr :logo-src="config.logoSrc" :margin="0" :auto-color="true" :text="config.value" :size="200" :dot-scale="1" ref="payCode"></vue-qr>
        </div>
        <div class="icon-box">
          <div class="sameicon icon1"></div>
          <div class="sameicon icon2"></div>
          <div class="sameicon icon3"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="coedDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改弹窗 -->
    <el-dialog title="设备管理" :visible.sync="modifyDeviceDialog" width="30%" class="modify-device-dialog" :before-close="cancelDevice">
      <el-form :model="modifyForm" :rules="modifyFormRules" ref="modifyForm" label-width="120px" class="demo-ruleForm" v-show="activeTab === 1 || (activeTab === 2&&!isZfbBox)">
        <el-form-item label="码牌名称" prop="transToolCustomerName">
          <el-input v-model="modifyForm.transToolCustomerName" placeholder="请输入码牌名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="收款事项/内容" prop="fixedQrcodeDescription">
          <el-input v-model="modifyForm.fixedQrcodeDescription" placeholder="请输入收款事项/内容" clearable></el-input>
        </el-form-item>
        <el-form-item label="固定金额" prop="fixedAmount">
          <el-input v-model="modifyForm.fixedAmount"  placeholder="请输入固定金额" clearable></el-input>
        </el-form-item>
        <span class="desc">0.01~10000元之间。如经营票务固定商品，可开启固定金额 功能，不做设置，则顾客在扫码时需手动输入金额</span>
      </el-form>
      <el-form :model="modifyNameForm" :rules="modifyNameFormRules" ref="modifyNameForm" label-width="120px" class="demo-ruleForm" v-show="activeTab === 3 || activeTab === 4||(activeTab === 2&&isZfbBox)">
        <el-form-item label="设备名称" prop="transToolCustomerName">
          <el-input v-model="modifyNameForm.transToolCustomerName" placeholder="请输入设备名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDevice">取 消</el-button>
        <el-button type="primary" @click="submitInfo('modifyForm')" v-show="activeTab === 1 || (activeTab === 2&&!isZfbBox)">确 定</el-button>
        <el-button type="primary" @click="submitInfoName('modifyNameForm')" v-show="activeTab === 3 || activeTab === 4||(activeTab === 2&&isZfbBox)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import VueQr from "vue-qr";
import CustomSelect from "@/components/CustomSelect/index.vue";
import { queryShopList } from "@/api/merchant-info";
import { listTransToolInfo, updateTransToolInfo, getQrcodePage } from "@/api/device-manage";

export default {
  components: {
    CustomSelect,
    VueQr,
  },
  data() {
    const checkMoney = (rule, value, callback) => {
      const isNum = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value !== '' && !isNum.test(value)) {
        callback(new Error('请输入数字值'));
      } else if (parseFloat(value) > 10000 || parseFloat(value) < 0.01) {
        callback(new Error('金额必须在0.01-10000元之间'));
      } else {
        callback();
      }
    };
    return {
      activeTab: 1,
      shopList: [],
      searchForm: {
        merchantIdList: [],
        transToolNum: "",
        transToolCustomerName: "",
      },
      modifyForm: {
        transToolCustomerName: "",
        fixedAmount: "",
        fixedQrcodeDescription: "",
        transToolNum: "",
        merchantId: "",
      },
      modifyNameForm: {
        transToolCustomerName: "",
        merchantId: "",
        transToolNum: "",
        qrcodeType: "",
      },
      modifyFormRules: {
        transToolCustomerName: [
          { required: true, message: "请输入码牌名称", trigger: "blur" },
          {
            min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '名称不支持特殊字符和空格', trigger: 'blur',
          },
        ],
        fixedQrcodeDescription: [
          {
            min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur",
          },
        ],
        fixedAmount: [{ validator: checkMoney, trigger: 'blur' }],
      },
      modifyNameFormRules: {
        transToolCustomerName: [
          { required: true, message: "请输入码牌名称", trigger: "blur" },
          {
            min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '名称不支持特殊字符和空格', trigger: 'blur',
          },
        ],
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      code: {
        fixedAmount: 0,
        fixedQrcodeDescription: "",
      },
      loadingTable: false,
      coedDialog: false,
      modifyDeviceDialog: false,
      codeLoading: false,
      tableData: [],
      // 二维码配置
      config: {
        value: "",
        logoSrc: require("../../assets/images/device-manege/logo.png"), // 中间logo的地址
      },
      isZfbBox: false,
      shopType: 1,
    };
  },
  watch: {
    activeTab() {
      this.queryData();
      this.searchForm.transToolNum = "";
      this.searchForm.transToolCustomerName = "";
    },
  },
  methods: {
    // 获取门店列表
    queryShopList() {
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo: 1,
        pageSize: 1000,
      };
      return queryShopList(params).then((res) => {
        if (res.data.error_code === 0) {
          res.data.data.list.unshift({ merchantId: "@", merchantName: "全部门店", checked: true });
          this.shopList = res.data.data.list;
          this.searchForm.merchantIdList = [this.shopList[0].merchantId];
          this.queryData();
        }
      });
    },
    // 收款码和云喇叭修改
    modifyDetial(row) {
      this.modifyDeviceDialog = true;
      this.$nextTick(() => {
        this.modifyForm.transToolCustomerName = row.transToolCustomerName;
        this.modifyForm.fixedQrcodeDescription = row.fixedQrcodeDescription;
        this.modifyForm.fixedAmount = row.fixedAmount ? row.fixedAmount / 100 : "";
        this.modifyForm.transToolNum = row.transToolNum;
        this.modifyForm.merchantId = row.merchantId;
        this.modifyNameForm.transToolCustomerName = row.transToolCustomerName;
        this.modifyNameForm.merchantId = row.merchantId;
        this.modifyNameForm.transToolNum = row.transToolNum;
        this.modifyNameForm.qrcodeType = row.qrcodeType ? row.qrcodeType : "";
        this.isZfbBox = row.qrcodeType === 10;
      });
    },
    submitInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.modifyForm));
          /* eslint-disable-next-line */
          for (const k in params) {
            if (params[k] === '') {
              delete params[k];
            }
          }
          params.toolType = this.activeTab;
          if (params.fixedAmount) {
            params.fixedAmount *= 100;
          }
          this.submitModifyAip(params);
        }
      });
    },
    submitInfoName(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = Object.assign(this.modifyNameForm, { toolType: this.activeTab });
          this.submitModifyAip(params);
        }
      });
    },
    submitModifyAip(params) {
      updateTransToolInfo(params).then((res) => {
        console.log(res.data.error_code);
        if (res.data.error_code === 0) {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
          this.queryData();
          this.modifyDeviceDialog = false;
        }
      });
    },
    cancelDevice() {
      this.$nextTick(() => {
        this.modifyDeviceDialog = false;
        this.modifyForm = Object.assign({ transToolCustomerName: "", fixedQrcodeDescription: "", fixedAmount: "" });
        this.modifyNameForm = Object.assign({ transToolCustomerName: "" });
        if (this.$refs.modifyForm !== undefined) {
          this.$refs.modifyForm.resetFields();
        } else if (this.$refs.modifyNameForm !== undefined) {
          this.$refs.modifyNameForm.resetFields();
        }
      });
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryData();
    },
    search() {
      this.page.pageNo = 1;
      this.queryData();
    },
    queryData() {
      const parramSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      const params = Object.assign(parramSearchForm, this.page);
      params.toolType = this.activeTab;
      if (params.merchantIdList.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择至少1个以上的门店",
          type: "error",
        });
        return;
      }
      // 如果是全部门店，需要遍历获取所有的门店id
      if (this.searchForm.merchantIdList[0] === "@") {
        params.merchantIdList = [];
        this.shopList.forEach((v) => {
          if (v.merchantId !== "@") {
            params.merchantIdList.push(v.merchantId);
          }
        });
      }
      this.loadingTable = true;
      listTransToolInfo(params).then((res) => {
        if (res.data.error_code === 0) {
          this.tableData = res.data.data.list;
          this.page.count = res.data.data.totalCount;
        }
        // 让用户可以更好的感受tab切换效果
        setTimeout(() => {
          this.loadingTable = false;
        }, 100);
      });
    },
    viewCodeDetial(row) {
      this.coedDialog = true;
      this.code = row;
      const params = {
        merchantId: row.merchantId,
        qrcodeNum: row.transToolNum,
      };
      this.codeLoading = true;
      getQrcodePage(params).then((res) => {
        this.codeLoading = false;
        if (res.data.error_code === 0) {
          this.config.value = res.data.data.qrcodeUrl;
        }
      });
    },
  },
  created() {
    this.queryShopList();
    if (JSON.parse(window.localStorage.getItem('LOGIN_INFO'))) {
      this.shopType = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).shopType;
    }
  },
};
</script>
<style lang="scss">
.device-con {
  //   background-color: #f7f7f7;
  .tabs {
    padding-left: 50px;
    background-color: #fff;
    display: flex;
    border-bottom: 1px solid #f2f3f3;
    height: 80px;
    align-items: center;
    .item {
      height: 80px;
      line-height: 80px;
      cursor: pointer;
      color: #333333;
      font-size: 18px;
      margin-right: 60px;
      &.active {
        border-bottom: 2px solid #ff9600;
      }
    }
  }
  .search {
    .label {
      font-size: 14px;
      width: 80px;
    }
    padding: 40px 50px 20px 50px;
    .el-row {
      margin-bottom: 15px;
    }
    .el-col {
      .label {
        height: 38px;
        line-height: 38px;
      }
    }
    .el-form--inline .el-form-item__label {
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      min-width: 83px;
      .el-form-item__content {
        overflow: hidden;
      }
    }
    .btnBase {
      float: right;
      width: 90px;
      height: 32px;
      line-height: 0px;
    }
  }
  .table-list {
    background: #f7f7f7;
    overflow: hidden;
    .tabledata-con {
      border-top: 20px solid #eee;
      padding: 40px 50px;
      background: #fff;
      overflow: hidden;
      .table-btn {
        margin-right: 20px;
        cursor: pointer;
        color: #ff9600;
      }
      .last-btn{
        margin-right: 0;
      }
    }
  }
  .code {
    text-align: center;
    .text {
      margin-bottom: 25px;
    }
    .money {
      font-size: 30px;
      font-weight: bold;
      span {
        font-size: 14px;
      }
    }
    .name {
      font-size: 18px;
    }
    .icon-box {
      display: flex;
      width: 160px;
      margin: 20px auto 0;
       justify-content: space-between;
      .sameicon {
        width: 40px;
        height: 40px;
      }
      .icon1 {
        background: url("../../assets/images/device-manege/wx.png") no-repeat;
        background-size: 100%;
      }
      .icon2 {
        background: url("../../assets/images/device-manege/zfb.png") no-repeat;
        background-size: 100%;
      }
      .icon3 {
        background: url("../../assets/images/device-manege/ysf.png") no-repeat;
        background-size: 100%;
      }
    }
  }
  .codeImg {
    text-align: center;
  }
  .modify-device-dialog {
    .el-form-item__label {
      text-align: left;
      color: #333;
      font-weight: normal;
    }
    .el-dialog__header {
      color: #000;
      font-size: 22px;
      font-weight: bold;
      padding: 40px 0 0 40px;
    }
    .el-dialog__body {
      padding: 50px 40px;
    }
    .el-dialog__footer {
      padding: 0px 40px 40px;
    }
    .desc {
      margin-left: 120px;
      display: block;
      line-height: 18px;
      color: #ccc;
      font-size: 12px;
    }
  }
}
</style>
